"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClient = void 0;
var client_1 = require("@apollo/client");
var links_1 = require("../links");
var localFields_1 = require("../localFields");
var createApolloClient = function (employeeId, currentStage, region) {
    var authLink = (0, links_1.createAuthenticationLink)(currentStage);
    var restLink = (0, links_1.createRestLink)(currentStage);
    var httpLink = (0, links_1.createHttpLink)(employeeId, currentStage, region);
    var metricsLink = (0, links_1.createMetricsLink)();
    var errorLink = (0, links_1.createErrorLink)();
    var retryLink = (0, links_1.createRetryLink)();
    return new client_1.ApolloClient({
        link: (0, client_1.from)([
            authLink,
            retryLink,
            restLink,
            metricsLink,
            errorLink,
            httpLink
        ]),
        cache: new client_1.InMemoryCache({
            typePolicies: __assign({}, localFields_1.localFields)
        }),
        connectToDevTools: true
    });
};
exports.createApolloClient = createApolloClient;
